/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserCheckIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB0ElEQVR4nOWVO0scURTHJ2gwlSBo0iS1fgHrQUEY2HseY7ieM1lhuy22S2Vlb75ButSK4CcIJoE8ilhoArYWsYqGRHwbEjm7sw9dR0dmrbxwYODO/P5zfvcwEwT3YhHJM2RZBtY9K2RZQfSjPYMD6S6y/r9Y8sv2Cgcgy3I3PC3SpcIBUFeSEcDy504DgPR34QC0A81UJIvFA9CP2oF2v73sxHH5adCzMSVdMuf1IlnsGfxOl70lkMwB63tg2QbSv8h6hiRbwLqKqC/jePbxrcFRFA0gyyskOcoe0dYknQDJfBiG/fng3o8A68ebwNg9UZ+iqDx4LbxarT5Ekne3hnPaDetqWKk8ygyoa8kPPAaS00tdHLnpZMxYpsxUXzjQnM53HSXPvfd9BnCU1CzMnoVYo6ZmJF1D1h+tAJuWfBpk+nLnjpPQqn2GspF+DNfaAawfOlrdzNLive9r6NQ3Nr6dY2rXSPot/RCuO5cMdwTIdrqxD7FOXq1HTptekeRtev93AH1yLbyhSA9TBa8RZyayFDlKanUtLhk2UDOkURnwtOUFZD1w8cw4xDqFrP8y/gE/gyB4YM+USi+GgOVrx97V8CLLgMDyBUk/9xyeZ50DVG+5cE0AXKQAAAAASUVORK5CYII=)
 */
export const UserCheckIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM11.53 11A9.53 9.53 0 0 0 2 20.53c0 .81.66 1.47 1.47 1.47h.22c.24 0 .44-.17.5-.4.29-1.12.84-2.17 1.32-2.91.14-.21.43-.1.4.15l-.26 2.61c-.02.3.2.55.5.55h6.4a.5.5 0 0 0 .35-.85l-.02-.03a3 3 0 1 1 4.24-4.24l.53.52c.2.2.5.2.7 0l1.8-1.8c.17-.17.2-.43.06-.62A9.52 9.52 0 0 0 12.47 11h-.94Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M23.7 17.7a1 1 0 1 0-1.4-1.4L18 20.58l-2.3-2.3a1 1 0 0 0-1.4 1.42l3 3a1 1 0 0 0 1.4 0l5-5Z"
        className={colorClass}
      />
    </svg>
  );
};
